import AmexShopSmallBuyoutTabs from './AmexShopSmallBuyoutTabs';

export default AmexShopSmallBuyoutTabs;
